/**
 * 会员模块路由
 * topNav: members
 */
export default {
  path: 'members',
  name: 'Members',
  component: () => import('@/layout/RouteView.vue'),
  meta: { title: '会员', titleKey: 'routes.members', topNav: 'members', icon: 'TeamOutlined' },
  children: [
    // 会员管理（分组）
    {
      path: 'member-management',
      name: 'MemberManagement',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '会员管理', titleKey: 'routes.memberManagement', icon: 'UserOutlined' },
      children: [
        {
          path: 'list',
          name: 'MemberList',
          component: () => import('@/views/members/member-management/member-list/index.vue'),
          meta: { title: '会员列表', titleKey: 'routes.memberList', permission: 'member:view' },
        },
        {
          path: 'list/detail/:id',
          name: 'MemberDetail',
          component: () => import('@/views/members/member-management/member-list/detail.vue'),
          meta: {
            title: '会员详情',
            titleKey: 'routes.memberDetail',
            hidden: true,
            permission: 'member:viewDetail',
          },
        },
        {
          path: 'level-privilege',
          name: 'MemberLevelPrivilege',
          component: () => import('@/views/members/member-management/level-privilege/index.vue'),
          meta: {
            title: '会员等级特权',
            titleKey: 'routes.memberLevelPrivilege',
            permission: 'member:level:view',
          },
        },
        {
          path: 'level-privilege/add',
          name: 'MemberLevelAdd',
          component: () => import('@/views/members/member-management/level-privilege/addEdit.vue'),
          meta: {
            title: '新增会员等级',
            titleKey: 'routes.memberLevelAdd',
            hidden: true,
            permission: 'member:level:create',
          },
        },
        {
          path: 'level-privilege/edit/:id',
          name: 'MemberLevelEdit',
          component: () => import('@/views/members/member-management/level-privilege/addEdit.vue'),
          meta: {
            title: '编辑会员等级',
            titleKey: 'routes.memberLevelEdit',
            hidden: true,
            permission: 'member:level:update',
          },
        },
        {
          path: 'decoration',
          name: 'MemberDecoration',
          component: () => import('@/views/members/member-management/decoration/index.vue'),
          meta: {
            title: '会员装修',
            titleKey: 'routes.memberDecoration',
            permission: 'member:decoration:view',
            contentPlain: true,
          },
        },
        {
          path: 'blacklist',
          name: 'BlacklistManagement',
          component: () => import('@/views/members/member-management/blacklist/index.vue'),
          meta: {
            title: '黑名单管理',
            titleKey: 'routes.blacklistManagement',
            permission: 'member:blacklist:view',
          },
        },
        {
          path: 'basic-config',
          name: 'MemberBasicConfig',
          component: () => import('@/views/members/member-management/basic-config/index.vue'),
          meta: {
            title: '基础配置',
            titleKey: 'routes.memberBasicConfig',
            permission: 'member:basic:view',
          },
        },
      ],
    },
    // 积分（分组）
    {
      path: 'points',
      name: 'Points',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '积分', titleKey: 'routes.points', icon: 'BarChartOutlined' },
      children: [
        {
          path: 'issue-detail',
          name: 'PointsIssueDetail',
          component: () => import('@/views/members/points/points-issue-detail.vue'),
          meta: {
            title: '发放明细',
            titleKey: 'routes.pointsIssueDetail',
            permission: 'points:issue-detail',
          },
        },
        {
          path: 'issue-stats',
          name: 'PointsIssueStats',
          component: () => import('@/views/members/points/points-issue-stats.vue'),
          meta: {
            title: '发放统计',
            titleKey: 'routes.pointsIssueStats',
            permission: 'points:issue-stats',
          },
        },
        {
          path: 'config',
          name: 'PointsConfig',
          component: () => import('@/views/members/points/points-config.vue'),
          meta: { title: '积分配置', titleKey: 'routes.pointsConfig', permission: 'points:config' },
        },
      ],
    },
    // 积分商城（分组）
    {
      path: 'mall',
      name: 'PointsMall',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '积分商城', titleKey: 'routes.pointsMall', icon: 'ShoppingOutlined' },
      children: [
        {
          path: 'product',
          name: 'PointsProduct',
          component: () => import('@/views/members/mall/product/index.vue'),
          meta: {
            title: '积分商品',
            titleKey: 'routes.pointsProduct',
            permission: 'mall:product:view',
          },
        },
        {
          path: 'product/add',
          name: 'PointsProductAddEdit',
          component: () => import('@/views/members/mall/product/addEdit.vue'),
          meta: {
            title: '添加礼品',
            titleKey: 'routes.pointsProductAddEdit',
            hidden: true,
            permission: 'mall:product:create',
          },
        },
        {
          path: 'category',
          name: 'PointsProductCategory',
          component: () => import('@/views/members/mall/category/index.vue'),
          meta: {
            title: '商品分类',
            titleKey: 'routes.pointsProductCategory',
            permission: 'mall:category:view',
          },
        },
        {
          path: 'exchange-record',
          name: 'ExchangeRecord',
          component: () => import('@/views/members/mall/exchange-record/index.vue'),
          meta: {
            title: '兑换记录',
            titleKey: 'routes.exchangeRecord',
            permission: 'mall:exchange:view',
          },
        },
        {
          path: 'decoration',
          name: 'MallDecoration',
          component: () => import('@/views/members/mall/decoration/index.vue'),
          meta: {
            title: '商城装修',
            titleKey: 'routes.mallDecoration',
            permission: 'mall:decoration:view',
            contentPlain: true,
          },
        },
        {
          path: 'exchange-stats',
          name: 'ExchangeStats',
          component: () => import('@/views/members/mall/exchange-stats/index.vue'),
          meta: {
            title: '兑换统计',
            titleKey: 'routes.exchangeStats',
            permission: 'mall:stats:view',
          },
        },
      ],
    },
  ],
};
